import React from 'react'
import { properties } from '../Data/E_Offer'

const Description = ({product}) => {
  return (
     <div className='flex flex-col items-center py-2'>
          <div  className="text-start"> 
         <p className="pb-5 text-[22px] text-[#000] text-start font-outfit mt-4">
            {product.description}
              </p>
              <ul >
  <li className="pb-2 text-[22px] pt-2 text-[#000] font-outfit">
    ✔️ Premium 100% Cotton – soft, breathable & durable
  </li>
  <li className="pb-2 text-[18px] text-[#000] font-outfit">
    ✔️ Minimalist design (embroidered-style print)
  </li>
  <li className="pb-2 text-[18px] text-[#000] font-outfit">
    ✔️ Lightweight & comfortable for all-day wear
  </li>
  <li className="pb-2 text-[18px] text-[#000] font-outfit">
    ✔️ Unisex fit – suitable for both men and women
  </li>
  <li className="pb-2 text-[18px] text-[#000] font-outfit">
    ✔️ Perfect for artist, painters, and art lovers
  </li>
  <li className="pb-2 text-[18px] text-[#000] font-outfit">
    ✔️ Machine-washable, fade-resistant print
  </li>
</ul>
         </div>
      <div className='flex flex-wrap gap-[1rem] items-center justify-center py-[1rem] mt-[1rem]'>
            {properties.map((data,index)=>(
                 <div className='flex items-center justify-center flex-col gap-[1rem] w-[250px] h-[300px]' key={index}>
                     <div className='flex items-center justify-center w-[130px] h-[130px] rounded-[50%] bg-black'>
                        <img src={data.icon} alt={data.title} />
                     </div>
                     <h3 className='font-cinzel text-[20px]'>{data.title}</h3>
                 </div> 
            ))}
      </div>
      

     </div>
  )
}

export default Description
